// Copyright ©️ 2026 eVolve MEP, LLC

import type { WorkOrderPaginated } from '@evolvemep/api-ts';
import { Card, Flex, Stack, Text } from '@mantine/core';

import { EntityStatusBadge } from 'components/Mantine/EntityStatusBadge';
import { useEvolveNavigate } from 'components/Mantine/Navigation/useEvolveNavigate';

type Props = {
  workOrder: WorkOrderPaginated;
};

export const SelectableWorkOrderCard = ({ workOrder }: Props) => {
  const navigate = useEvolveNavigate('Work Orders');

  return (
    <Card
      bg="gray.1"
      onClick={() => navigate(`/work-orders/${workOrder.workOrderId}`)}
      style={{
        cursor: 'pointer',
      }}
      py="xs"
      flex="1 0 auto"
    >
      <Flex justify="space-between" align="center">
        <Stack gap={0}>
          <Text>{workOrder.name}</Text>
          <Text fz="sm" c="dimmed">
            {workOrder.identifier}
          </Text>
        </Stack>

        <EntityStatusBadge
          customStatusEntityName="Work Order"
          stateName={workOrder.workOrderStateName}
          statusId={workOrder.workOrderStatusId}
        />
      </Flex>
    </Card>
  );
};
